import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/logo/bucket.svg'
import _imports_1 from '@/assets/img/logo/arrow.svg'


const _hoisted_1 = { class: "w-full overflow-scroll lg:overflow-hidden h-auto overflow-x-hidden top-0 left-0 bg-white lg:relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-5 mr-1"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full pb-4 border-solid border-t border-[#f2f4f5] lg:block hidden" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-heading text-[16px] p-3 rounded-xl bg-[#f9f9f9] w-11/12 mx-auto lg:w-full flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "🔍"),
  /*#__PURE__*/_createTextVNode(" 개체 종")
], -1)
const _hoisted_5 = { class: "flex flex-col mt-4 h-auto min-h-screen" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-def font-medium text-[16px]" }
const _hoisted_8 = { class: "px-4" }
const _hoisted_9 = { class: "ps-8 text-[15px]" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-full pb-4 border-solid border-t border-[#f2f4f5]" }, null, -1)
const _hoisted_13 = { key: 0 }

import { ref, computed } from 'vue';
import categoryData from '@/assets/data/category.json';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getUserId, isTokenExpired, accessToken } from '@/utils/Functions';
import ConfirmModal from '../UI/ConfirmModal.vue';

interface Item{
    toggle : boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SpeciesFilter',
  setup(__props) {

const store = useStore();
const category = ref(categoryData);
const router = useRouter();
const loginMsg = ref('');
const isOpen = ref(false);
const selectedJong = ref('');
const handleMobileSpecies = computed(() => store.state.handleMobileSpecies)

const handleToggle = (item :Item) => {
    item.toggle = !item.toggle;
}
  const resetValues = {
    price: '',
    location: '',
    gender: '',
    size: '',
    city : '',
    town : '',
    toggle : false,
  };
  store.commit('SET_STATUS_FILTER', resetValues);
const selectedSpecies = computed(()=> store.state.selectedSpecies);
// 종 선택하고, 리스트 변경하기
const setSpecies = async (specice:string) => {
    selectedJong.value = null
    store.commit('SET_SPECIES_STATUS', specice);
    store.commit('SET_MORPH_STATUS',[]);
    store.commit('SET_NO_RESULT', false);
    store.commit('SET_KEYWORD_STATUS', null);
    store.commit('SET_STATUS_FILTER', resetValues);
    store.commit('SET_TEMPORARY_FILTER', resetValues);

    if(!store.state.categories[specice]){
        await store.dispatch('fetchCategoryData', specice);
    }
    store.commit('SET_CURRENT_LIST', store.state.categories[specice]?.data || []);
    store.commit('SET_CURRENT_STATUS', 1);
    store.commit('SET_MOBILE_SPEICES_MODAL', false);
    router.push('/reptile')
}

const setTotal = async (jong) => {
    selectedJong.value = jong
    // console.log(jong)
    store.commit('SET_SPECIES_STATUS', jong);
    store.commit('SET_MORPH_STATUS',[]);
    store.commit('SET_NO_RESULT', false);
    store.commit('SET_KEYWORD_STATUS', null);
    store.commit('SET_STATUS_FILTER', resetValues);
    store.commit('SET_TEMPORARY_FILTER', resetValues);

    if(!store.state.categories[jong]){
        await store.dispatch('fetchHamburgerData', jong);
    }
    store.commit('SET_CURRENT_LIST', store.state.categories[jong]?.data || []);
    store.commit('SET_CURRENT_STATUS', 3);
    store.commit('SET_MOBILE_SPEICES_MODAL', false)
    router.push('/reptile')
}
const goWrite = () => {
    if (accessToken.value === null) {
        loginMsg.value = '로그인을 해주세요';
//         loginMsg.value = 
// `세션이 만료되었습니다. 
// 다시 로그인해주세요.`;
        isOpen.value = true;
        return;
    }
    if (isTokenExpired(accessToken.value)) {
        loginMsg.value = 
`세션이 만료되었습니다. 
다시 로그인해주세요.`;
        isOpen.value = true;
        return;
    }
    router.push('/reptile/write');
};
const closeModal = () => {
    // isOpen.value = !isOpen.value
    isOpen.value = false;
}   
const closeBtn = () => {
    store.commit('SET_MOBILE_SPEICES_MODAL', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "font-thin text-4xl w-full flex lg:hidden justify-end px-6 my-4",
        onClick: closeBtn
      }, "×"),
      _createElementVNode("div", {
        class: "border-[#A3A7B0] border border-solid cursor-pointer text-sm lg:flex justify-center items-center w-full h-11 font-bold rounded-md text-[#646669] hidden",
        onClick: goWrite
      }, [
        _hoisted_2,
        _createTextVNode(" 분양글 쓰기 ")
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.value, (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: "flex flex-col space-y-5 cursor-pointer"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-row flex justify-between pl-8 pr-4 lg:pr-0", { 'hover-item': !item.toggle }]),
              onClick: ($event: any) => (handleToggle(item))
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.category), 1),
              _createElementVNode("button", _hoisted_8, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "arrowBtn",
                  style: _normalizeStyle({ transform: item.toggle ? 'rotate(90deg)' : 'rotate(-90deg)', transition: 'all .3s' })
                }, null, 4)
              ])
            ], 10, _hoisted_6),
            _withDirectives(_createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", {
                class: _normalizeClass(["hover:translate-x-2 transition duration-200 py-2", selectedJong.value === item.category ?  'text-[#17181A] font-semibold ' : 'text-[#84888C]' ]),
                onClick: ($event: any) => (setTotal(item.category))
              }, "전체보기 ", 10, _hoisted_10),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.species, (specices, idx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: idx,
                  class: _normalizeClass(["hover:translate-x-2 transition duration-200 py-2", selectedSpecies.value === specices ?  'text-[#17181A] font-semibold ' : 'text-[#84888C]' ])
                }, [
                  _createElementVNode("p", {
                    onClick: ($event: any) => (setSpecies(specices))
                  }, _toDisplayString(specices), 9, _hoisted_11)
                ], 2))
              }), 128))
            ], 512), [
              [_vShow, item.toggle]
            ]),
            _hoisted_12
          ]))
        }), 128))
      ])
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(ConfirmModal, {
            content1: loginMsg.value,
            onUpdateClose: closeModal,
            closeButton: "닫기"
          }, null, 8, ["content1"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})